// HB-1978: detect an edge/WAF rate-limit rejection of a DTF artwork upload so the
// flow can show an accurate "high traffic — please wait" message instead of the
// generic "Image upload failed". Two shapes:
//   - CloudFront/WAF block: HTTP 403 with the CloudFront HTML body containing
//     "Request blocked" (TEMP-DtfArtworksRateLimit, 10 req/60s/IP). The body is a
//     non-JSON string, so there is no structured error_code to key on.
//   - Server-side throttle: HTTP 429 (e.g. Rack::Attack).
// A genuine application 403 (JSON body, no "Request blocked") is deliberately NOT
// matched — uploads on this path are guest-allowed, so an app 403 is not expected,
// and the signature check keeps us from mislabelling one as rate-limiting.
export const isEdgeRateLimited = (error: unknown): boolean => {
  const status = (error as { response?: { status?: number } })?.response?.status;
  if (status === 429) return true;
  if (status !== 403) return false;

  const data = (error as { response?: { data?: unknown } })?.response?.data;
  return typeof data === "string" && /request blocked/i.test(data);
};
